var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Grid, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import React from 'react';
export var DefaultAccordionFilter = function (_a) {
    var children = _a.children, sx = _a.sx, _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.subTitle, subTitle = _c === void 0 ? '' : _c, _d = _a.defaultExpanded, defaultExpanded = _d === void 0 ? true : _d;
    return (_jsx(Grid, __assign({ container: true, spacing: 2, sx: sx || { my: 2 } }, { children: _jsx(Grid, __assign({ item: true, xs: 12, sm: 12 }, { children: _jsxs(Accordion, __assign({ defaultExpanded: defaultExpanded, style: { borderRadius: '14px' } }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, {}), "aria-controls": "panel1a-content", id: "panel1a-header" }, { children: _jsxs(Container, __assign({ style: { marginLeft: '-21px' } }, { children: [_jsx(Typography, __assign({ variant: "h6", fontWeight: 'bold', gutterBottom: true }, { children: title })), _jsx(Typography, __assign({ variant: "subtitle2" }, { children: subTitle }))] })) })), _jsx(AccordionDetails, { children: _jsx(Grid, __assign({ container: true, spacing: 2 }, { children: children })) })] })) })) })));
};
